import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ee027da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-current" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-current-1" }, " Unternehmensdaten ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-current-2" }, [
  /*#__PURE__*/_createTextVNode(" Unternehmen:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Co:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Land:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Plz:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Stadt:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Straße:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Nr:"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_4 = { class: "user-current-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "user-current" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-current-1" }, " Kontaktdaten ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-current-2" }, [
  /*#__PURE__*/_createTextVNode(" Anrede:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Titel:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Vorname:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Nachname:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Funktion:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Telefon:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" E-Mail:"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_16 = { class: "user-current-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, _toDisplayString(_ctx.user.username), 1),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.user.company), 1),
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.user.co), 1),
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.user.land), 1),
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.user.plz), 1),
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.user.city), 1),
        _hoisted_9,
        _createTextVNode(" " + _toDisplayString(_ctx.user.street), 1),
        _hoisted_10,
        _createTextVNode(" " + _toDisplayString(_ctx.user.nr), 1),
        _hoisted_11,
        _hoisted_12
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createTextVNode(_toDisplayString(_ctx.user.salutation), 1),
        _hoisted_17,
        _createTextVNode(" " + _toDisplayString(_ctx.user.title), 1),
        _hoisted_18,
        _createTextVNode(" " + _toDisplayString(_ctx.user.firstName), 1),
        _hoisted_19,
        _createTextVNode(" " + _toDisplayString(_ctx.user.lastName), 1),
        _hoisted_20,
        _createTextVNode(" " + _toDisplayString(_ctx.user.position), 1),
        _hoisted_21,
        _createTextVNode(" " + _toDisplayString(_ctx.user.phone), 1),
        _hoisted_22,
        _createTextVNode(" " + _toDisplayString(_ctx.user.email), 1),
        _hoisted_23,
        _hoisted_24
      ])
    ])
  ], 64))
}